import React from "react";
import classes from "./Header.scss";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { ArrowRightPaneOutlined, HelpBulbFilled } from "@toddle-edu/ds-icons";
import classNames from "classnames";

const Header = props => {
  const { onClose, testId, title } = props;

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <HelpBulbFilled size="xx-small" className={classes.bulbIcon} />
        <Tooltip tooltip={title}>
          <h6 className={classNames("text-primary", "truncate")}>{title}</h6>
        </Tooltip>
      </div>
      <IconButton
        icon={<ArrowRightPaneOutlined />}
        onClick={onClose}
        type="plain"
        variant="neutral"
        testId={`${testId}-helperPane-close`}
        dsVersion="2.0"
      />
    </div>
  );
};

export default Header;
